import React from 'react';
import bindAll from 'lodash.bindall';
import PaintEditor from 'scratch-paint';

import Modal from '../modal/modal.jsx';

import styles from './paint-editor-modal.css';
import PropTypes from 'prop-types';

class PaintEditorModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [

        ]);
    }

    render () {
        return (
            <Modal
                className={styles.modal}
                onRequestClose={this.props.onRequestClose}
            >
                <PaintEditor
                    {...this.props}
                    onUpdateImage={this.props.onUpdateImage}
                    onUpdateName={this.props.onUpdateName}
                />
            </Modal>
        );
    }
}

PaintEditorModal.propTypes = {
    imageFormat: PropTypes.string.isRequired,
    imageId: PropTypes.string.isRequired,
    name: PropTypes.string,
    onRequestClose: PropTypes.func,
    onUpdateImage: PropTypes.func,
    onUpdateName: PropTypes.func,
    rotationCenterX: PropTypes.number,
    rotationCenterY: PropTypes.number,
    selectedCostumeIndex: PropTypes.number.isRequired
};

export default PaintEditorModal;
